import React from 'react'
import { Route, BrowserRouter as Router } from 'react-router-dom'

import createAuthRequiredPage from "./auth/pages/createAuthRequiredPage.js"

import MainPage from "./ext-src/MainPage.js"
import LogInPage from "./ext-src/auth/LoginPage.js"
import SignUpPage from "./ext-src/auth/SignupPage.js"
import UserSettingsPage from "./ext-src/user/components/UserSettingsPage.js"
import UserProfilePage from "./ext-src/user/components/UserProfilePage.js"
import ArticleEditorPage from "./ext-src/article/components/ArticleEditorPage.js"
import ArticleViewPage from "./ext-src/article/components/ArticleViewPage.js"


const router = (
  <Router>
    <div>
      <Route exact path="/" component={ MainPage }/>
      <Route exact path="/login" component={ LogInPage }/>
      <Route exact path="/register" component={ SignUpPage }/>
      <Route exact path="/settings" component={ createAuthRequiredPage(UserSettingsPage) }/>
      <Route exact path="/@:username" component={ UserProfilePage }/>
      <Route exact path="/editor/:articleSlug?" component={ createAuthRequiredPage(ArticleEditorPage) }/>
      <Route exact path="/article/:articleSlug" component={ ArticleViewPage }/>

    </div>
  </Router>
)

export default router
